module.exports = __webpack_public_path__ + "static/img/111.1d46049.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/111.jpg
// module id = HccB
// module chunks = 1